export default {
  hooks: {
    useUserProfile: {
      notifications: {
        updateSuccess: "Profile updated successfully",
        updateError: "An error occurred while updating the profile",
      },
    },
  },
};
